import userHelper from 'utils/user'
import hasBillesAccess from 'utils/hasBillesAccess'

function prepareModuleFieldsForCurrentUser({ state }) {
  let { currentUser, modules, helper: { admin: { user } } } = state.get(
    'client'
  )
  if (currentUser) {
    let currentUserHelper = userHelper(currentUser)
    modules.forEach(module => {
      let userModule = currentUserHelper.getModuleByName(module.module)
      let selectedOption = []
      let options = module.groups.reduce((acc, group, index) => {
        if (!(!user.isBilles && hasBillesAccess(group.access))) {
          const { access, name } = group
          let option = {
            key: access,
            value: name,
            index
          }
          if (
            userModule &&
            userModule.group === name &&
            userModule.access === access
          ) {
            selectedOption = [option]
            option.selected = true
          }
          acc.push(option)
        }

        return acc
      }, [])
      state.merge(`client.registrating.current.modules.${module.module}`, {
        value: selectedOption,
        options
      })
    })
  }
}

export default prepareModuleFieldsForCurrentUser



// WEBPACK FOOTER //
// ./src/modules/user/actions/prepareModuleFieldsForCurrentUser.js